import Markdown from 'react-markdown';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { Icon } from '@/components/ui/icon';

const COLORS = {
  brand: 'text-brand-400',
  blue: 'text-blue-400',
  green: 'text-green-400',
  red: 'text-red-400',
  yellow: 'text-yellow-400',
  purple: 'text-purple-400',
  black: 'text-black'
};

const H1 = ({ title, subtitle, subtitleColor, subtitleIcon, text, h1align: align, htmlId, fontSizeMobile, fontSize }) => {
  let classNameAlign = 'text-left';
  if (align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (align === 'right') {
    classNameAlign = 'text-right';
  }

  const subtitleColorClass = COLORS[subtitleColor] || 'text-black';

  return (
    <>
      {(subtitle || subtitleIcon) && (
        <VisibleLoading delay={75}>
          {({ ref, className }) => (
            <div
              ref={ref}
              className={`mx-auto mb-4 flex items-center justify-center gap-4 ${classNameAlign} ${className || ''}`}
            >
              {subtitleIcon && (
                <div className="border-brand-400 text-brand-400 flex h-12 w-12 items-center justify-center rounded-full border-[1.5px]">
                  <Icon type={subtitleIcon} width={28} height={28} />
                </div>
              )}

              {subtitle && (
                <div className={`txt-md font-semibold uppercase ${subtitleColorClass} ${className || ''}`.trim()}>
                  {subtitle}
                </div>
              )}
            </div>
          )}
        </VisibleLoading>
      )}

      <VisibleLoading delay={100}>
        {({ ref, className }) => (
          <h1
            id={htmlId}
            ref={ref}
            className={`mb-4 ${classNameAlign} ${className || ''}`.trim()}
            style={{
              ...(fontSizeMobile ? { fontSize: `${fontSizeMobile}px` } : {}),
              ...(fontSize ? { '--title-font-size-lg': `${fontSize}px` } : {})
            }}
          >
            {title}
          </h1>
        )}
      </VisibleLoading>

      {text && (
        <VisibleLoading delay={150}>
          {({ ref, className }) => (
            <div ref={ref} className={`txt-xl text-grey-700 mb-8 max-w-[544px] ${classNameAlign} ${className} [&_a]:underline`.trim()}>
              <Markdown
                components={{
                  a: ({ href, children }) => {
                    const isExternal = href && !href.startsWith('/') && !href.startsWith('#');
                    return (
                      <a href={href} {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                        {children}
                      </a>
                    );
                  }
                }}
              >
                {text}
              </Markdown>
            </div>
          )}
        </VisibleLoading>
      )}
    </>
  );
};
export default H1;
